import { Button, Modal, Switch } from "@material-ui/core";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { db } from "../../../firebase";
import "./AllowAccess.css";

function AllowAccess({ auth, name, authID, token }) {
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    setChecked(auth);
  }, [auth]);
  // console.log(name);

  //sending notifications to user
  const accessHandler = async (value) => {
    setChecked(value);
    await db.collection("Users").doc(authID).update({ isAuthenticated: value });
    if (value) {
      try {
        await axios.post("https://arham-app.herokuapp.com/notification", {
          message:
            "Welcome to Jain Samaj!, now you can create your profile and join the community",
          token,
        });
      } catch (e) {
        console.log(e);
      }
    } else {
      try {
        await axios.post("https://arham-app.herokuapp.com/notification", {
          message:
            "You access has been revoked, please contact admin (+91 98118 62846) for futher queries",
          token,
        });
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <div>
      {/* Modal */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <div className="card__modal">
          {!checked
            ? `Do you really want to Authenticate ${name}`
            : `Remove Authentication of ${name}?`}

          <div style={{ textAlign: "center" }}>
            <Button
              style={{ border: "1px solid black", padding: "2px" }}
              onClick={() => {
                if (!checked) accessHandler(true);
                else accessHandler(false);
                setOpen(false);
              }}
            >
              OK
            </Button>
          </div>
        </div>
      </Modal>
      {/* ------ */}
      <label>
        <b style={{ color: "red" }}>Allow Access</b>:
        <Switch
          checked={checked}
          color="primary"
          // defaultChecked={false}
          onChange={(e) => setOpen(true)}
        />
      </label>
    </div>
  );
}

export default AllowAccess;
